import styled from 'styled-components'

export const ListLoadingWrapperStyled = styled.div<{ $isLoading: boolean }>`
  opacity: ${(props) => (props.$isLoading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.$isLoading ? 'none' : 'auto')};
`
